module.exports = __webpack_public_path__ + "img/fish3.1d81c723.png";